import { WorkspaceParticipant } from './workspace-info';

export enum DriveContentType {
  FILE = 'file',
  FOLDER = 'folder',
}

export type IDriveContent = {
  _id: string;
  type: DriveContentType;
  parent?: string;
  name: string;
  user: string;
  totalFiles?: number;
  size?: number;
  url?: string;
  mimeType?: string;
  participants: WorkspaceParticipant[];
  isPublic?: boolean;
  isFavorited: boolean;
  createdAt: string;
  updatedAt: string;
};

export type IDrivePublicContent = IDriveContent & {
  childrens?: IDrivePublicContent[];
  content?: IPublicContentMetadata;
};

export type IPublicContentMetadata = {
  _id: string;
  contentRef: string;
  token: string;
  createdAt: string;
  updatedAt: string;
  user: string;
  workspace: string;
};

export type IDriveContentAncestors = Pick<IDriveContent, '_id' | 'name'> & {
  ancestors: (Pick<IDriveContent, '_id' | 'name'> & { level: number })[];
};
